import { Checkbox } from '@mui/material';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import FormControlLabel from '@mui/material/FormControlLabel';
import Grid from '@mui/material/Grid';
import React from 'react';

import { DimensionsService, type TimeDimension } from '~/services/dimensions';
import type { FilterName } from '~/app/routes/view-page';

interface FilterDialogProps {
  onDone: (dimensions: FilterName[], emissions: string[]) => void;
}

interface FilterDialogState {
  open: boolean;
  allEmissions: TimeDimension[];
  selectedEmissions: string[];
  allDimensions: FilterName[];
  selectedDimensions: FilterName[];
}

export class FilterDialogRaw extends React.Component<FilterDialogProps, FilterDialogState> {
  public static readonly ALL_AVAILABLE_FILTERS: FilterName[] = [
    'Version',
    'CRF',
    'NFR',
    'Category',
    'Classification',
    'Undergrupp',
    'Measure',
    'Secret',
    'Gas',
    'Unit',
    'Source',
    'Method',
    'Target',
    'Option',
    'Type',
    'UID',
  ];

  constructor(props: FilterDialogProps) {
    super(props);
    this.state = {
      open: false,
      allEmissions: [],
      allDimensions: [],
      selectedEmissions: [],
      selectedDimensions: [],
    };
  }

  public async componentDidMount(): Promise<void> {
    const allEmissions = await DimensionsService.getEmissionYears();
    this.setState({ allEmissions });
  }

  public openDialog(selectedEmissions: string[], selectedDimensions: FilterName[]): void {
    this.setState({ open: true, selectedEmissions, selectedDimensions });
  }

  private closeDialog(): void {
    const sortedDimensions = FilterDialogRaw.ALL_AVAILABLE_FILTERS.filter((x) =>
      this.state.selectedDimensions.includes(x)
    );
    this.setState({ open: false });
    this.props.onDone(sortedDimensions, this.state.selectedEmissions.sort());
  }

  private emissionChange(e: React.ChangeEvent<any>): void {
    if (e.target.checked) {
      this.state.selectedEmissions.push(e.target.value);
    } else {
      this.state.selectedEmissions.splice(this.state.selectedEmissions.indexOf(e.target.value), 1);
    }

    this.setState({ selectedEmissions: [...this.state.selectedEmissions] });
  }

  private dimensionChange(e: React.ChangeEvent<any>): void {
    if (e.target.checked) {
      this.state.selectedDimensions.push(e.target.value);
    } else {
      this.state.selectedDimensions.splice(this.state.selectedDimensions.indexOf(e.target.value), 1);
    }

    this.setState({ selectedDimensions: [...this.state.selectedDimensions] });
  }

  private toggleSelectAll(allSelected: boolean) {
    this.setState({
      selectedEmissions: allSelected ? [] : this.state.allEmissions.map((e) => e.name),
    });
  }

  public render(): React.ReactNode {
    const allSelected =
      JSON.stringify(this.state.allEmissions.map((e) => e.name).sort()) ===
      JSON.stringify(this.state.selectedEmissions.sort());
    return (
      <Dialog open={this.state.open} onClose={() => this.closeDialog()} aria-labelledby="form-dialog-title">
        <DialogTitle id="form-dialog-title">Inställningar för granskning</DialogTitle>
        <DialogContent>
          <DialogContentText>Här kan du ställa in vilka kolumner som ska visas.</DialogContentText>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <DialogContentText>Välj dimensioner:</DialogContentText>
            </Grid>
            {FilterDialogRaw.ALL_AVAILABLE_FILTERS.map((dimension) => (
              <Grid item xs={4} key={dimension}>
                <FormControlLabel
                  control={<Checkbox value={dimension} />}
                  label={dimension}
                  disabled={dimension === 'Version'}
                  checked={this.state.selectedDimensions.includes(dimension)}
                  onChange={(e) => this.dimensionChange(e)}
                />
              </Grid>
            ))}
          </Grid>
          <Grid container spacing={2}>
            <Grid item xs={9}>
              <DialogContentText>Välj emissionsår:</DialogContentText>
            </Grid>
            <Grid item xs={3}>
              <Button onClick={() => this.toggleSelectAll(allSelected)} color={'primary'}>
                {allSelected ? 'Ta bort alla' : 'Välj alla'}
              </Button>
            </Grid>
            {this.state.allEmissions.map((emission) => (
              <Grid item xs={2} key={emission.name}>
                <FormControlLabel
                  control={<Checkbox value={emission.name} />}
                  label={emission.name}
                  checked={this.state.selectedEmissions.includes(emission.name)}
                  onChange={(e) => this.emissionChange(e)}
                />
              </Grid>
            ))}
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => this.closeDialog()} color="primary">
            Avbryt
          </Button>
          <Button onClick={() => this.closeDialog()} color="primary">
            Filtrera
          </Button>
        </DialogActions>
      </Dialog>
    );
  }
}
export const FilterDialog = FilterDialogRaw;
